// src/db.js
import Dexie from 'dexie';

export const db = new Dexie('pawinhand-db');

db.version(1).stores({
  story:
    // idx(프라이머리) 포함, 나머지는 인덱스. 요청하신 모든 컬럼을 명시
    'story_idx, category_idx, story_title, story_contents1, story_image1, story_r_date, update_date',
  statistics:
    'idx, rescue_count, adopt_count, protect_count, update_date',
  youtube:
    'idx, image, title, url, update_date',
  help:
    'notify_number, image, update_date'
});

db.version(2).stores({
  story: 'story_idx, category_idx, story_title, story_contents1, story_image1, story_r_date, update_date, [category_idx+update_date]',
  statistics:
    'idx, rescue_count, adopt_count, protect_count, update_date',
  youtube:
    'idx, image, title, url, update_date',
  help:
    'notify_number, image, update_date'
}).upgrade(tx => {
  // 데이터 이동 필요 없음 (인덱스만 추가)
});


export async function initDB() {
  await db.open();
  return db;
}